/**
 * The built-in default platform brand (ADR-0045 Amendment TO-541): the brand
 * every surface binds when the runtime platform-brand pointer is unset or
 * unreachable. Backend resolvers and the frontend app import this one constant.
 */
export const DEFAULT_PLATFORM_BRAND_ID = 'aurora'
